import { api } from '../api';

export interface ManualDto {
  id: string;
  /** 다운로드 파일명(.pdf 제외) 겸 표시 이름 */
  title: string;
}

/** 현재 권한으로 받을 수 있는 매뉴얼 목록 */
export async function listManuals(): Promise<ManualDto[]> {
  const res = await api.get<ManualDto[]>('/manuals');
  return res.data;
}

/**
 * 매뉴얼 PDF 다운로드.
 *
 * 서버가 마크다운 원본에서 PDF를 만들어 디스크에 캐시하므로, 두 번째 요청부터는
 * 생성 없이 캐시본이 내려온다. 프런트는 별도 캐시를 두지 않는다.
 */
export async function downloadManual(id: string, fallbackName: string): Promise<void> {
  const res = await api.get(`/manuals/${id}.pdf`, { responseType: 'blob' });
  const filename = parseFilename(res.headers['content-disposition']) ?? fallbackName;
  const blobUrl = URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

function parseFilename(header: string | undefined): string | null {
  if (!header) return null;
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8?.[1]) {
    try {
      return decodeURIComponent(utf8[1]);
    } catch {
      // fall through
    }
  }
  const ascii = /filename="([^"]+)"/i.exec(header);
  return ascii?.[1] ?? null;
}
